export interface ResultadoPaginacion<T> {
  paginadas: T[];
  pagina: number;
  totalPaginas: number;
}

export const TAMANOS_PAGINA = [10, 20, 50] as const;
export type TamanoPagina = (typeof TAMANOS_PAGINA)[number];

export function calcularPaginacion<T>(items: T[], pagina: number, filasPorPagina: number): ResultadoPaginacion<T> {
  const totalPaginas = Math.max(1, Math.ceil(items.length / filasPorPagina));
  const paginaEfectiva = Math.min(Math.max(1, pagina), totalPaginas);
  const inicio = (paginaEfectiva - 1) * filasPorPagina;
  return {
    paginadas: items.slice(inicio, inicio + filasPorPagina),
    pagina: paginaEfectiva,
    totalPaginas,
  };
}
